import { Statistics } from 'src/api';
import { StatisticsStateInterface } from 'src/store/statistics/state';
import StatCountValue = Statistics.Types.StatCountValue;
import StatPoint = Statistics.Types.StatPoint;
import StatPointList = Statistics.Types.StatPointList;
import StatIncrementValue = Statistics.Types.StatIncrementValue;
import PendingPostings = Statistics.Types.PendingPostings;

const addCount = (
  collection: StatPointList,
  data: StatIncrementValue
): StatPointList => {
  const item: StatPoint = collection.pop() || {
    count: 0,
    timestamp: new Date().toUTCString(),
  };
  return [...collection, { ...item, count: item.count + data.value }];
};

export function SET_PERIOD(state: StatisticsStateInterface, payload: string) {
  state.period = payload;
}

export function SET_VALIDATION_FAILURES(
  state: StatisticsStateInterface,
  payload: StatPointList
) {
  state.validationFailures = payload;
}
export function ADD_VALIDATION_FAILURES(
  state: StatisticsStateInterface,
  payload: StatIncrementValue
) {
  state.validationFailures = addCount(state.validationFailures, payload);
}

export function SET_VALIDATION_SUCCESS(
  state: StatisticsStateInterface,
  payload: StatPointList
) {
  state.validationSuccess = payload;
}
export function ADD_VALIDATION_SUCCESS(
  state: StatisticsStateInterface,
  payload: StatIncrementValue
) {
  console.log(
    '[not supported] ADD_VALIDATION_SUCCESS',
    state.validationSuccess
  );
  state.validationSuccess = addCount(state.validationSuccess, payload);
}

export function SET_DELIVERED_POSTINGS(
  state: StatisticsStateInterface,
  payload: StatPointList
) {
  state.deliveredPostings = payload;
}
export function ADD_DELIVERED_POSTINGS(
  state: StatisticsStateInterface,
  payload: StatIncrementValue
) {
  state.deliveredPostings = addCount(state.deliveredPostings, payload);
}

export function SET_DELIVERED_NEW_POSTINGS(
  state: StatisticsStateInterface,
  payload: StatPointList
) {
  state.deliveredNewPostings = payload;
}
export function ADD_DELIVERED_NEW_POSTINGS(
  state: StatisticsStateInterface,
  payload: StatIncrementValue
) {
  state.deliveredNewPostings = addCount(state.deliveredNewPostings, payload);
}

export function SET_DELIVERY_FAILURES(
  state: StatisticsStateInterface,
  payload: StatCountValue
) {
  state.deliveryFailures = payload;
}
export function ADD_DELIVERY_FAILURES(
  state: StatisticsStateInterface,
  payload: StatIncrementValue
) {
  state.deliveryFailures = {
    count: state.deliveryFailures.count + payload.value,
  };
}

export function SET_IN_PROCESS_POSTINGS(
  state: StatisticsStateInterface,
  payload: StatPointList
) {
  state.inProcessPostings = payload;
}
export function ADD_IN_PROCESS_POSTINGS(
  state: StatisticsStateInterface,
  payload: StatIncrementValue
) {
  state.inProcessPostings = addCount(state.inProcessPostings, payload);
}

export function SET_PENDING_POSTINGS(
  state: StatisticsStateInterface,
  payload: PendingPostings
) {
  state.pendingPostings = payload;
}

export function SET_DELIVERY_LOADING(
  state: StatisticsStateInterface,
  loading: boolean
) {
  state.loading.delivery = loading;
}

export function SET_VALIDATION_LOADING(
  state: StatisticsStateInterface,
  loading: boolean
) {
  state.loading.validation = loading;
}

export function SET_IN_PROCESS_LOADING(
  state: StatisticsStateInterface,
  loading: boolean
) {
  state.loading.inProcess = loading;
}
